import { useCommunityContext } from '@/providers/community-context';
import { BusinessDirectoryView } from './business-directory-view';
import { Loader2 } from 'lucide-react';

export default function BusinessDirectoryPage() {
  const { community: currentCommunity, isLoading } = useCommunityContext();

  if (isLoading) return <Loader2 className="h-8 w-8 animate-spin text-primary mx-auto mt-12" />;
  if (!currentCommunity) return null;

  return <BusinessDirectoryView community={currentCommunity} />;
}
